export interface Override {
  id: number;
  carrierCode: string;
  bookingCode: string | null;
  fareFamily: string;
  fareFamilyNormalized: string;
  gds: string | null;
  correctShelve: string;
  wrongShelve: string | null;
  confirmed: string;
  international: string | null;
  fareBasis: string | null;
  comments: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface Carrier {
  code: string;
  name: string;
}

export interface PaginationInfo {
  page: number;
  per_page: number;
  total: number;
  total_pages: number;
}

export interface OverrideListResponse {
  data: Override[];
  pagination: PaginationInfo;
}

export interface CreateOverrideInput {
  carrier_code: string;
  booking_code?: string | null;
  fare_family: string;
  gds?: string | null;
  correct_shelve: string;
  wrong_shelve?: string | null;
  confirmed: string;
  international?: string | null;
  fare_basis?: string | null;
  comments?: string | null;
}

export interface ConflictError {
  error: string;
  message: string;
  details: {
    conflicting_rules: Array<{
      id: number;
      carrier_code: string;
      booking_code: string | null;
      fare_family: string;
      gds: string | null;
      correct_shelve: string;
      confirmed: string;
    }>;
  };
}

export const SHELVE_VALUES = [
  'ONE_STAR',
  'TWO_STARS',
  'THREE_STARS',
  'FOUR_STARS',
  'FIVE_STARS',
] as const;

export const CONFIRMED_VALUES = ['Yes', 'No', 'QA Only'] as const;
export const GDS_VALUES = ['s', 'a'] as const;

export const SHELVE_LABELS: Record<string, string> = {
  ONE_STAR: 'Basic',
  TWO_STARS: 'Standard',
  THREE_STARS: 'Premium',
  FOUR_STARS: 'Business',
  FIVE_STARS: 'First Class',
};

export interface AuditEntry {
  id: number;
  action: string;
  overrideId: number | null;
  userEmail: string | null;
  sourceDomain: string | null;
  oldData: string | null;
  newData: string | null;
  createdAt: string;
}

export interface AuditLogResponse {
  data: AuditEntry[];
  pagination: PaginationInfo;
}
